const Error = () => (
  <div
    className="bg-red-100 border border-red-500  px-4 py-3"
    role="alert"
  >
    <p className="font-bold">Wystąpił problem</p>
    <p className="text-sm">Spróbuj ponownie za jakiś czas</p>
  </div>
);

export default Error;
